import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import RetakeQuizImg from "Images/profile/retake_quiz.png";
import RetakeQuizVerticallImg from "Images/profile/retake_quiz_verticall.png";
import LargeFont from "../../common/LargeFont";
import RegFont from "../../common/RegFont";
import UnderlinedButton from "../../common/UnderlinedButton";
import "./retakeQuiz.scss";
import { useRetakeQuizData } from "../../RetakeQuizDrawer/useRetakeQuizData";
import RetakeQuizDrawer from "../../RetakeQuizDrawer";
import { LoadUserCartThunk } from "Root/profile/redux/thunkCreators/products/userCart";
import { useDispatch } from "react-redux";
import { fetchProfileDataThunk } from "Root/profile/redux/thunkCreators/myProfile/profileThunk";
const RetakeQuiz = ({ asDrawer = true, className = null }) => {
    const data = useRetakeQuizData();
    const dispatch = useDispatch();
    const onClick = () => {
        data.toggleDrawer(true)();
    };
    const submitAnswers = async () => {
        await data.updateQuizData();
        await dispatch(LoadUserCartThunk());
        await dispatch(fetchProfileDataThunk());
    };
    return (_jsx(_Fragment, { children: asDrawer ? (_jsxs("div", { className: `${className || ""} my-profile__retake-quiz`, children: [_jsxs("div", { className: "my-profile__retake-quiz-container", children: [_jsxs("div", { className: "my-profile__retake-quiz-wrapper", children: [_jsx(LargeFont, { fontWeight: 400, children: "Retake the Quiz" }), _jsx(RegFont, { children: "New goals, new dietary needs, we got you covered. Retake the quiz for recommendations that reflect the new you." })] }), _jsx(UnderlinedButton, { onClick: onClick, label: " Update Your Profile" }), _jsx(RetakeQuizDrawer, { ...data, submitAnswers: submitAnswers, asDrawer: asDrawer }), _jsx("img", { className: "my-profile__retake-quiz-image hide-on-med-and-down", src: RetakeQuizImg, alt: "" })] }), _jsx("img", { className: "my-profile__retake-quiz-image-vertical hide-on-large-only", src: RetakeQuizVerticallImg, alt: "" })] })) : (_jsx(RetakeQuizDrawer, { ...data, submitAnswers: submitAnswers, openDrawer: true, asDrawer: asDrawer })) }));
};
export default RetakeQuiz;
